// src/app/useControleRole.js — l'entrée « Contrôle » (sonde contrôleur) et
// le renvoi de chaque rôle vers ses onglets. Déplacé à l'identique depuis
// src/App.jsx (P-3.5, squelette).

import { useState, useEffect } from 'react'
import { sonderControleur } from '../lib/controle-api'

export function useControleRole({ tab, setTab, currentUser }) {
  // CONTRÔLE DES MÉNAGES (UI) — l'entrée « Contrôle » n'existe que si le compte
  // est CONTRÔLEUR : le client ne connaît pas le périmètre à l'avance, seule la
  // sonde serveur (controle_a_controler) le sait — 200 avec liste (même vide) =
  // contrôleur ; 403 = pas contrôleur → l'onglet n'apparaît PAS. Aucun droit
  // conféré ici : le périmètre réel est re-vérifié serveur à chaque action.
  const [estControleur, setEstControleur] = useState(false)
  // Arrivée CIBLÉE dans l'onglet Contrôle depuis la frise du Suivi (bouton
  // « Contrôler » orchestrateur) — consommée une fois par ControleView.
  const [controleDest, setControleDest] = useState(null)
  useEffect(() => {
    const r = currentUser?.role
    if (r !== 'menage' && r !== 'orchestrateur') { setEstControleur(false); return }
    let annule = false
    sonderControleur().then((ok) => { if (!annule) setEstControleur(ok) })
    return () => { annule = true }
  }, [currentUser])

  // Phase 4 PR 4 + PR #134 (ADR-076) + CHANTIER 42 Phase 3 — Onglets autorisés AGENT.
  // Ménage : 'menage-today' (défaut) + 'menage-calendrier' + 'incidents' + 'stock'.
  // Orchestrateur : 'menage-suivi' (défaut) + 'menage-calendrier' + 'incidents' +
  // 'stock' (PAS 'menage-today' — l'écran agent). Tout autre tab → redirect vers le
  // défaut du rôle.
  // B1 — `isAgentUI` n'est pas encore en scope ici (déclaré plus bas, post-garde
  // proprio) ; on inline la condition agent. SANS cette redirection, le tab reste
  // 'calendrier' (jamais redirigé) → écran vide au login.
  useEffect(() => {
    const r = currentUser?.role
    if (r === "menage" || r === "orchestrateur") {
      // CHANTIER 42 Phase 3 (recalibrage) — l'orchestrateur pilote via
      // 'menage-suivi' (écran UNIQUE) et N'a PAS 'menage-today' (l'écran agent) :
      // s'il y atterrit, il est redirigé vers 'menage-suivi'. Le ménage garde
      // 'menage-today' et N'a PAS 'menage-suivi' (réservé orchestrateur). Le défaut
      // dépend du rôle (sinon écran vide au login).
      const isOrch = r === "orchestrateur"
      // 'menage-controle' n'est autorisé que si la sonde a confirmé le statut
      // de contrôleur (cf. estControleur ci-dessus).
      const allowed = isOrch
        ? ['menage-suivi', 'orchestrateur-horaires', 'menage-calendrier', 'menage-avis', 'incidents', 'stock', ...(estControleur ? ['menage-controle'] : [])]
        // Maquette NEST v677 (lot G2) : plus de « Mon sac » chez l'agent.
        : ['menage-today', 'mon-travail', ...(estControleur ? ['menage-controle'] : [])]
      if (!allowed.includes(tab)) setTab(isOrch ? 'menage-suivi' : 'menage-today')
    } else if (r && r !== "admin" && tab === "accueil") {
      // LOT 1 — filet : 'accueil' est un écran ADMIN. Un rôle qui n'est ni
      // admin ni agent (proprio a déjà `return` plus haut) retombe sur
      // 'calendrier', exactement là où il atterrissait avant ce lot.
      setTab("calendrier")
    }
  }, [currentUser, tab, estControleur])
  return { estControleur, setControleDest, controleDest }
}
